import { api, routes } from "../helpers/api";
import { ContactSchemaType } from "../schemas/contact-schema";

export const sendContactDetails = async (data: ContactSchemaType) => {
    const result = await api.post(routes.server + '/landing/contact', { to: "contact@myorcare.com", details: data })
    return result;
}